import { Button, Modal } from 'react-bootstrap';

export const BasicModal = ({ 
    showModal, 
    title, 
    children, 
    successFunction, 
    onHide, 
    cancelButtonTitle="Cancel" ,
    actionButtonTitle="Reset"}) => {

    return (
        <>
            <Modal show={showModal}
                onHide={onHide}
                size='lg'
                centered={true} >

                <Modal.Header>
                    <Modal.Title className='d-flex justify-content-center align-items-center'>{title}</Modal.Title>
                </Modal.Header>

                <Modal.Body >
                    <div className='d-flex w-100'>
                        {children}
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <Button onClick={() => onHide()} className="ModalSecondaryButton neo_qv_btn">{ cancelButtonTitle }</Button>
                    <Button onClick={() => successFunction()} className="ModalPrimaryButton neo_btn_primary">{ actionButtonTitle }</Button>
                </Modal.Footer>

            </Modal>
        </>
    )
}
